<template>
    <element-badge :color="statusColor" uppercase>{{ review.status }}</element-badge>
</template>

<script>
import Review from '@/Models/Review';
import ReviewStatus from '@/Enums/ReviewStatus';

export default {
    props: {
        review: {
            type: Review,
            required: true,
        },
    },

    computed: {
        statusColor() {
            switch (this.review.status) {
                case ReviewStatus.REJECTED:
                    return 'red';
                case ReviewStatus.PENDING:
                    return 'yellow';
                case ReviewStatus.APPROVED:
                default:
                    return 'green';
            }
        },
    },
};
</script>
